export default "assets/images/logo_footer-9d179674.png";